import { useMatch } from 'react-router-dom';
import {
  ROUTE_KYC_LANDING,
  ROUTE_MOBILE_LANDING,
  ROUTE_SIGNUP,
} from '../../../routes';
import { isFeatureOn } from '../../../whitelabel';
import { Features } from '../../../whitelabel/type';

export function useShouldShowHeader(): boolean {
  const isNewSignup = useMatch(ROUTE_SIGNUP) && isFeatureOn(Features.NewSignup);
  const isNew2FAPage = useMatch(ROUTE_KYC_LANDING) && isFeatureOn(Features.Kyc);
  const isCapacitorLanding = useMatch(ROUTE_MOBILE_LANDING);
  return !isNewSignup && !isCapacitorLanding && !isNew2FAPage;
}
